// @flow

import moment from 'moment-timezone';

import type {
  Schedule,
  ScheduleObjectList
} from '../../../../types/journeysScheduleTypes';

export function getSchedule(
  schedules: ScheduleObjectList,
  ruleId: string
): ?Schedule {
  if (schedules) {
    const scheduleId = Object.keys(schedules).find(key => {
      return schedules[key] && schedules[key].owner_id === ruleId;
    });
    if (scheduleId) {
      return schedules[scheduleId];
    }
  }
  return;
}

export function shouldSchedule(schedule: Schedule) {
  if (schedule && schedule.status === 'ACTIVE') {
    if (
      !schedule.start_date_time ||
      moment
        .tz(
          schedule.start_date_time.slice(0, 19),
          schedule.start_date_time && schedule.start_date_time.slice(20, 100)
        )
        .isBefore(moment.tz())
    ) {
      return false;
    }
    return true;
  } else {
    return false;
  }
}
